import { useMemoizedFn } from 'ahooks';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { cn } from '@/utils/tw_common';
import { isValidUrl } from '@/utils/url/isValidUrl';
import { Button } from '@/components/button';
import { pay } from '@/api/buy';
import i18n from '@/locales/init';

export interface IPayButtonProps {
  orderNumber: string;
  /**
   * 支付方式：1支付宝 2微信
   */
  type: number;
}

export const PayButton = ({ orderNumber, type }: IPayButtonProps) => {

  const [url, setUrl] = useState<string>('');
  const [disabled, setDisabled] = useState<boolean>(false);

  useEffect(() => {
    if (!orderNumber) {
      return;
    }
    // if (type === 2) {
    //   return;
    // }

    const redirectUrl = window.location.href.replace(/\?_t=\d+/, '');
    setDisabled(true);

    pay({ order_num: orderNumber, pay_type: type, redirect_url: redirectUrl }).then((res) => {
      console.log('[sss]', res);
      if (res.code === 200 && res.data.orderStr) {
        setUrl(res.data.orderStr);
        setDisabled(false);
        return;
      } else {
        setDisabled(false);
        toast.error(res.msg);
      }
    });

  }, [orderNumber, type]);

  const handleClick = useMemoizedFn(() => {
    console.log('[][][]', orderNumber);
    // if (type === 2) {
    //   return;
    // }
    if (disabled){
      return;
    }
    if (isValidUrl(url)) {
      window.open(url, '_blank');
    }
  });

  // 临时使用，微信支付通过后删除
  // if (type === 2) {
  //   return <Button variant={'no_border'} disabled onClick={handleClick} className={cn('h-14 text-white rounded-full font-semibold text-[16px]', 'bg-[#28C445]')}>
  //     {i18n.t('敬请期待')}
  //   </Button>;
  // }

  return <Button variant={'no_border'} onClick={handleClick} className={cn('h-14 text-white rounded-full font-semibold text-[16px]', type === 1 ? 'bg-[#007FFF]' : 'bg-[#28C445]')}>
    {type === 1 ? i18n.t('支付宝支付') : i18n.t('微信支付')}
  </Button>;
};
